function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { assertIsDashboardPluginProps, DashboardUtils, LayoutUtils, useListener, usePanelRegistration } from '@deephaven/dashboard';
import { FileUtils } from '@deephaven/file-explorer';
import { isComponent } from '@deephaven/golden-layout';
import Log from '@deephaven/log';
import { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { nanoid } from 'nanoid';
import { ConsoleEvent, NotebookEvent } from "./events/index.js";
import { ConsolePanel, CommandHistoryPanel, FileExplorerPanel, LogPanel, NotebookPanel } from "./panels/index.js";
import { setDashboardConsoleSettings } from "./redux/index.js";
import useConfigureRuff from "./useConfigureRuff.js";
var log = Log.module('ConsolePlugin');
function isNotebookPanel(panel) {
  return panel.notebook !== undefined;
}
function assertIsConsolePluginProps(props) {
  assertIsDashboardPluginProps(props);
}
export function ConsolePlugin(props) {
  assertIsConsolePluginProps(props);
  var id = props.id,
    hydrateConsole = props.hydrateConsole,
    layout = props.layout,
    panelManager = props.panelManager,
    registerComponent = props.registerComponent,
    notebooksUrl = props.notebooksUrl;
  var notebookIndex = useRef(0);
  // Map from file ID to panel ID
  var _useState = useState(new Map()),
    _useState2 = _slicedToArray(_useState, 2),
    openFileMap = _useState2[0],
    setOpenFileMap = _useState2[1];
  var _useState3 = useState(new Map()),
    _useState4 = _slicedToArray(_useState3, 2),
    previewFileMap = _useState4[0],
    setPreviewFileMap = _useState4[1];
  useConfigureRuff();
  var dispatch = useDispatch();
  var getConsolePanel = useCallback(() => panelManager.getLastUsedPanelOfType(ConsolePanel), [panelManager]);
  var addOpenFileMapEntry = useCallback((key, value) => {
    setOpenFileMap(map => new Map(map.set(key, value)));
  }, [setOpenFileMap]);
  var deleteOpenFileMapEntry = useCallback(key => {
    setOpenFileMap(map => {
      map.delete(key);
      return new Map(map);
    });
  }, [setOpenFileMap]);
  var addPreviewFileMapEntry = useCallback((key, value) => {
    setPreviewFileMap(map => new Map(map.set(key, value)));
  }, [setPreviewFileMap]);
  var deletePreviewFileMapEntry = useCallback(key => {
    setPreviewFileMap(map => {
      map.delete(key);
      return new Map(map);
    });
  }, [setPreviewFileMap]);
  var handleSendCommand = useCallback(function (command) {
    var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var execute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var trimmedCommand = command && command.trim();
    if (!trimmedCommand) {
      log.info('Ignoring empty code');
    } else {
      var consolePanel = getConsolePanel();
      if (!consolePanel || !(consolePanel instanceof ConsolePanel.WrappedComponent)) {
        log.error('Console panel not found');
        return;
      }
      log.debug('Send command: ', command, focus, execute);
      consolePanel.addCommand(command, focus, execute);
    }
  }, [getConsolePanel]);
  var handleSettingsChanged = useCallback(consoleSettings => {
    dispatch(setDashboardConsoleSettings(id, consoleSettings));
  }, [dispatch, id]);
  var getNotebookFileName = useCallback(_ref => {
    var language = _ref.language;
    var extension = language === 'python' ? 'py' : language;
    var title = null;
    if (extension == null) {
      log.debug('No extension for language', language);
      title = "Untitled-".concat(notebookIndex.current);
    } else {
      title = "Untitled-".concat(notebookIndex.current, ".").concat(extension);
    }
    notebookIndex.current += 1;
    return title;
  }, []);
  var getPanelIdForFileMetadata = useCallback(function (fileMetadata) {
    var createIfNecessary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var fileId = fileMetadata.id;
    if (fileId != null && openFileMap.has(fileId)) {
      return openFileMap.get(fileId);
    }
    if (fileId != null && previewFileMap.has(fileId)) {
      return previewFileMap.get(fileId);
    }
    if (createIfNecessary) {
      return nanoid();
    }
    return undefined;
  }, [openFileMap, previewFileMap]);
  var renamePanel = useCallback((panelId, newTitle) => {
    LayoutUtils.renameComponent(layout.root, {
      id: panelId
    }, newTitle);
  }, [layout.root]);
  var renameFilePanel = useCallback((oldName, newName) => {
    log.debug('Rename file panel', oldName, newName);
    var panelId;
    if (openFileMap.has(oldName)) {
      panelId = openFileMap.get(oldName);
      deleteOpenFileMapEntry(oldName);
      if (panelId != null) {
        addOpenFileMapEntry(newName, panelId);
      }
    }
    if (previewFileMap.has(oldName)) {
      panelId = previewFileMap.get(oldName);
      deletePreviewFileMapEntry(oldName);
      if (panelId != null) {
        addPreviewFileMapEntry(newName, panelId);
      }
    }
    if (panelId === undefined) {
      log.debug2("File ".concat(oldName, " isn't open, no need to rename the tab"));
      return;
    }
    renamePanel(panelId, FileUtils.getBaseName(newName));
  }, [openFileMap, previewFileMap, renamePanel, addOpenFileMapEntry, addPreviewFileMapEntry, deleteOpenFileMapEntry, deletePreviewFileMapEntry]);

  /**
   * Show the panel for the given file metadata.
   * If the panel is not already open, then it just logs an error and does nothing.
   */
  var showFilePanel = useCallback(fileMetadata => {
    var panelId = getPanelIdForFileMetadata(fileMetadata, false);
    if (panelId == null) {
      log.error('Could not find panel id for file metadata', fileMetadata);
      return;
    }
    LayoutUtils.activateTab(layout.root, {
      id: panelId
    });
  }, [getPanelIdForFileMetadata, layout.root]);
  var registerFilePanel = useCallback((panelId, fileMetadata, isPreview) => {
    log.debug('registerFilePanel', panelId, fileMetadata, isPreview);
    if (fileMetadata == null || fileMetadata.id == null) {
      log.debug('Ignore empty file id', fileMetadata);
      return;
    }
    var fileId = fileMetadata.id;
    if (isPreview) {
      addPreviewFileMapEntry(fileId, panelId);
      return;
    }
    if (openFileMap.has(fileId)) {
      var existingPanelId = openFileMap.get(fileId);
      if (panelId === existingPanelId) {
        log.debug("Update tab title for file ".concat(fileId));
        var itemName = fileMetadata.itemName;
        renameFilePanel(fileId, itemName);
      } else {
        log.error("File ".concat(fileId, " already associated with a different tab ").concat(existingPanelId));
      }
      return;
    }
    addOpenFileMapEntry(fileId, panelId);

    // De-register preview tab
    if (previewFileMap.has(fileId)) {
      deletePreviewFileMapEntry(fileId);
    }
  }, [openFileMap, previewFileMap, renameFilePanel, addOpenFileMapEntry, addPreviewFileMapEntry, deletePreviewFileMapEntry]);
  var unregisterFilePanel = useCallback((fileMetadata, isPreview) => {
    log.debug('unregisterFileTab', fileMetadata, isPreview);
    if (fileMetadata == null || fileMetadata.id == null) {
      log.debug('Ignore empty file id', fileMetadata);
      return;
    }
    var fileId = fileMetadata.id;
    if (isPreview) {
      deletePreviewFileMapEntry(fileId);
      return;
    }
    deleteOpenFileMapEntry(fileId);
  }, [deleteOpenFileMapEntry, deletePreviewFileMapEntry]);
  var closeFilePanel = useCallback((fileMetadata, options) => {
    log.debug('closeFilePanel', fileMetadata);
    var fileId = fileMetadata.id;
    if (fileId == null) {
      log.warn('File ID is null, ignore close event');
      return;
    }
    var panelId = null;
    var isPreview = false;
    if (openFileMap.has(fileId)) {
      panelId = openFileMap.get(fileId);
    } else if (previewFileMap.has(fileId)) {
      panelId = previewFileMap.get(fileId);
      isPreview = true;
    } else {
      log.debug("File ".concat(fileId, " isn't open, ignore close event"));
      return;
    }
    unregisterFilePanel(fileMetadata, isPreview);
    LayoutUtils.closeComponent(layout.root, {
      id: panelId
    }, options);
  }, [layout.root, openFileMap, previewFileMap, unregisterFilePanel]);
  var getNotebookTitle = useCallback(fileMetadata => {
    var itemName = fileMetadata.itemName;
    return FileUtils.getBaseName(itemName);
  }, []);
  var fileIsOpen = useCallback(fileMetadata => {
    var fileId = fileMetadata.id;
    log.debug('fileIsOpen', fileMetadata, fileId, openFileMap);
    return fileId != null && openFileMap.has(fileId);
  }, [openFileMap]);
  var fileIsOpenAsPreview = useCallback(fileMetadata => {
    var fileId = fileMetadata.id;
    log.debug('fileIsOpenAsPreview', fileMetadata, fileId, previewFileMap);
    return fileId != null && previewFileMap.has(fileId);
  }, [previewFileMap]);

  /*
   * Attempts to focus the panel with the provided panelId
   */
  var focusPanelById = useCallback(panelId => {
    if (panelId == null) {
      return;
    }
    var panel = panelManager.getOpenedPanelById(panelId);
    if (panel && isNotebookPanel(panel)) {
      panel.focus();
    }
  }, [panelManager]);
  var makeConfig = useCallback(_ref2 => {
    var panelId = _ref2.id,
      settings = _ref2.settings,
      fileMetadata = _ref2.fileMetadata,
      session = _ref2.session,
      sessionLanguage = _ref2.sessionLanguage,
      _ref2$isPreview = _ref2.isPreview,
      isPreview = _ref2$isPreview === void 0 ? false : _ref2$isPreview;
    var panelState = {
      settings,
      fileMetadata
    };
    var title = getNotebookTitle(fileMetadata);
    return {
      type: 'react-component',
      component: NotebookPanel.COMPONENT,
      isFocusOnShow: false,
      props: {
        localDashboardId: id,
        metadata: {
          id: panelId
        },
        session,
        sessionLanguage,
        panelState,
        isPreview,
        notebooksUrl
      },
      title,
      id: panelId
    };
  }, [getNotebookTitle, id, notebooksUrl]);
  var createNotebook = useCallback(function (session, sessionLanguage, settings) {
    var fileMetadata = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      id: null,
      itemName: getNotebookFileName(settings)
    };
    var panelId = getPanelIdForFileMetadata(fileMetadata);
    if (fileIsOpen(fileMetadata) && panelId != null) {
      log.debug('File is already open, focus panel');
      showFilePanel(fileMetadata);
      focusPanelById(panelId);
      return;
    }

    // Should never happen because getPanelForFileMetadata will create an ID by default
    if (panelId == null) {
      log.error('Panel ID for file metadata is null');
      return;
    }
    var stack = LayoutUtils.getStackForComponentTypes(layout.root, [NotebookPanel.COMPONENT]);
    var config = makeConfig({
      id: panelId,
      settings,
      fileMetadata,
      session,
      sessionLanguage
    });
    log.debug('createNotebook', config, openFileMap);
    LayoutUtils.openComponentInStack(stack, config);
  }, [fileIsOpen, focusPanelById, getNotebookFileName, getPanelIdForFileMetadata, layout.root, makeConfig, openFileMap, showFilePanel]);
  var selectNotebook = useCallback(function (session, sessionLanguage, settings, fileMetadata) {
    var shouldFocus = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    log.debug('selectNotebook', fileMetadata, shouldFocus);
    var isFileOpen = fileIsOpen(fileMetadata);
    var isFileOpenAsPreview = fileIsOpenAsPreview(fileMetadata);
    var _ref3 = [...previewFileMap.values()],
      previewId = _ref3[0];
    var isPreview = !shouldFocus;
    var panelId = isPreview && previewId ? previewId : getPanelIdForFileMetadata(fileMetadata);
    if (panelId == null || panelId === '') {
      throw new Error("Unable to retrieve or create panelId for metadata: ".concat(JSON.stringify(fileMetadata)));
    }

    // If the file is already open, show it
    if (isFileOpen || isFileOpenAsPreview) {
      showFilePanel(fileMetadata);
    } else {
      var stack = LayoutUtils.getStackForComponentTypes(layout.root, [NotebookPanel.COMPONENT]);
      var config = makeConfig({
        id: panelId,
        settings,
        fileMetadata,
        session,
        sessionLanguage,
        isPreview
      });

      // This will replace the existing preview by panelId if needed
      LayoutUtils.openComponentInStack(stack, config);
    }

    // If the file is open as a preview and focused, promote to non-preview
    if (isFileOpenAsPreview && shouldFocus) {
      var fileId = fileMetadata.id;
      var _stack = LayoutUtils.getStackForConfig(layout.root, {
        component: NotebookPanel.COMPONENT,
        id: panelId
      });
      var item = LayoutUtils.getContentItemInStack(_stack, {
        component: NotebookPanel.COMPONENT,
        id: panelId
      });
      if (fileId != null && item && isComponent(item)) {
        item.container.emit(NotebookEvent.PROMOTE_FROM_PREVIEW);
        deletePreviewFileMapEntry(fileId);
        addOpenFileMapEntry(fileId, panelId);
      }
    }
    if (shouldFocus) {
      // Focus the tab if we're supposed to
      focusPanelById(panelId);
    }
  }, [showFilePanel, fileIsOpen, fileIsOpenAsPreview, focusPanelById, getPanelIdForFileMetadata, layout.root, makeConfig, previewFileMap, deletePreviewFileMapEntry, addOpenFileMapEntry]);

  /** Attempts to send the text to a notebook matching the passed in settings */
  var sendToNotebook = useCallback(function (session, sessionLanguage) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var createIfNecessary = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var notebookPanel = panelManager.getLastUsedPanelOfType(NotebookPanel);
    if (notebookPanel && isNotebookPanel(notebookPanel)) {
      if (settings != null && settings.value != null && notebookPanel.notebook != null) {
        notebookPanel.notebook.append(settings.value);
      }
    } else if (createIfNecessary) {
      createNotebook(session, sessionLanguage, settings);
    }
  }, [createNotebook, panelManager]);
  var hydrateNotebook = useCallback((panelProps, panelDashboardId) => DashboardUtils.hydrate(_objectSpread(_objectSpread({}, panelProps), {}, {
    notebooksUrl
  }), panelDashboardId), [notebooksUrl]);
  usePanelRegistration(registerComponent, ConsolePanel, hydrateConsole);
  usePanelRegistration(registerComponent, CommandHistoryPanel);
  usePanelRegistration(registerComponent, FileExplorerPanel);
  usePanelRegistration(registerComponent, LogPanel);
  usePanelRegistration(registerComponent, NotebookPanel, hydrateNotebook);
  useListener(layout.eventHub, ConsoleEvent.SEND_COMMAND, handleSendCommand);
  useListener(layout.eventHub, ConsoleEvent.SETTINGS_CHANGED, handleSettingsChanged);
  useListener(layout.eventHub, NotebookEvent.CLOSE_FILE, closeFilePanel);
  useListener(layout.eventHub, NotebookEvent.CREATE_NOTEBOOK, createNotebook);
  useListener(layout.eventHub, NotebookEvent.SELECT_NOTEBOOK, selectNotebook);
  useListener(layout.eventHub, NotebookEvent.RENAME, renamePanel);
  useListener(layout.eventHub, NotebookEvent.RENAME_FILE, renameFilePanel);
  useListener(layout.eventHub, NotebookEvent.SEND_TO_NOTEBOOK, sendToNotebook);
  useListener(layout.eventHub, NotebookEvent.REGISTER_FILE, registerFilePanel);
  useListener(layout.eventHub, NotebookEvent.UNREGISTER_FILE, unregisterFilePanel);
  return null;
}
export default ConsolePlugin;
//# sourceMappingURL=ConsolePlugin.js.map